<template>
  <li class="row-content" :class="containerClass">
    <div class="t-overflow">
      <i class="fa fa-users t-secondary t-xs mr-1"></i>
      <span class="t-600 t-sm" v-html="getResearchGroupsAsString()"></span>
    </div>
  </li>
</template>

<script>

export default {
  name: 'searchPartialResearchGroupsForBody',
  props: {
    researchGroups: {
      type: Array,
      required: true
    },
    highlights: {
      type: Object,
      required: true
    },
    highlightKey: {
      type: String,
      required: false,
      default: 'researchGroups.name'
    },
    containerClass: {
      type: String,
      default: ''
    },
    truncate: {
      type: Number,
      default: 50
    }
  },
  methods: {
    getResearchGroupsAsString () {
      let researchGroupStr = ''
      for (const [key, value] of this.researchGroups.entries()) {
        researchGroupStr += this.getResearchGroupName(value)
        if (key < this.researchGroups.length - 1) researchGroupStr += ', '
      }

      return researchGroupStr
    },
    getResearchGroupName (researchGroup) {
      if (this.highlights && this.highlights[this.highlightKey]) {
        let org = researchGroup.name
        for (let o of this.highlights[this.highlightKey]) if (researchGroup.name === this.stripTags(o)) org = o
        return this.$options.filters.truncate(org, this.truncate)
      } else if (researchGroup.name) {
        return this.$options.filters.truncate(researchGroup.name, this.truncate)
      }

      return this.$options.filters.truncate(researchGroup.name, this.truncate)
    }
  }
}
</script>
